<div class="modal modal--persist fade fade-up modal--fullscreen" id="edit-modal" tabindex="-1" role="dialog"
  aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-edit" [ngClass]="{'modal-edit--tpq': +product?.is_ei_product === 0}">
      <div class="modal-edit__content">
        <div class="modal-edit__content-inner">
          <div class="container">
            <div class="modal-edit__row">
              <div class="modal-edit__sidecol">
                <div class="modal-edit__sidecolinner">
                  @if (+product?.is_ei_product === 1) {
                    <div class="modal-edit__header">
                      <button class="button-control modal-edit__close" (click)="save()">
                        <svg class="icon">
                          <use xlink:href="#arrow-left-small"></use>
                        </svg>
                        Back to Summary
                      </button>
                    </div>
                  }
                  @if (product) {
                    <div class="card card--rating">
                      <div class="card-body">
                        <div class="modal-edit__company">
                          <div class="modal-edit__company-thumb">
                            <img
                              [src]="product?.underwriter_logo"
                              class="img-fluid summary-underwriter"
                              alt=""
                              />
                            </div>
                            <div class="modal-edit__company-rating">
                              <div class="stars-compact">
                                <div class="stars-compact__star">
                                  <svg class="icon">
                                    <use xlink:href="#star"></use>
                                  </svg>
                                </div>
                                <div class="stars-compact__num">
                                  {{product?.insurer_rating?.length ? product?.insurer_rating[0]?.insurer_rating : 0}}
                                </div>
                              </div>
                            </div>
                            <div class="modal-edit__company-price">
                              <p>
                                <strong class="product-price">
                                  {{ globalQuestionService?.accounting?.formatMoney(product?.price)}} /mo
                                </strong>
                              </p>
                            </div>
                            <div class="modal-edit__company-name">
                              <h6 class="product-name">{{product?.product_name}}</h6>
                            </div>
                            <div class="modal-edit__company-fees">
                              <p>Including Taxes and Fees <a
                                class="popover-trigger popover-trigger--hover popover-trigger--sm product-taxes-details"
                                tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true"
                            [attr.data-content]="
                            platform_fee?.description_1 + ' ' + globalQuestionService?.accounting?.formatMoney(platform_fee?.prem_value) +'<br>'+
                            taxes?.description_1 + ' ' + globalQuestionService?.accounting?.formatMoney(taxes?.prem_value)
                            "
                                data-original-title="" title="">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#help-Icon"></use>
                                </svg>
                              </a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    <div class="modal-edit__categories-trigger">
                      <a class="modal-edit__categories-title seemore collapsed" href="#categories-accordion"
                        data-toggle="collapse" data-text-collapsed="Change" data-text-expanded="Change"
                        aria-expanded="false">
                        <svg class="icon icon--sm">
                          <use xlink:href="#plus"></use>
                        </svg>
                        <svg class="icon icon--sm">
                          <use xlink:href="#minus"></use>
                        </svg>
                        <strong>Change</strong>
                        <span class="selected-category-title">class</span>
                      </a>
                      <p><strong class="selected-category-item">description</strong></p>
                    </div>

                    <div class="modal-edit__categories seemore__expander collapse" id="categories-accordion">
                      @if (locatons?.length > 0 ) {
                        <div class="card card--categories">
                          <a
                            href="#categories-location"
                            class="card-title collapsed"
                            data-toggle="collapse"
                            aria-expanded="true"
                            [ngClass]="{'collapsed': !locationActive}"
                            >
                            <div class="card-title__text">
                              <img
                                class="icon icon--lg"
                                alt=""
                                [src]="'assets/class/sm-0.svg'"
                                fallbackImage
                                />
                                <h4>Locations</h4>
                              </div>
                              <div class="card-title__caret">
                                <svg class="icon">
                                  <use xlink:href="#dropdown"></use>
                                </svg>
                              </div>
                            </a>
                            <div class="card-body collapse"  [ngClass]="{'show': locationActive }" id="categories-location" data-parent="#categories-accordion">
                              <div class="card__content">
                                <ul class="card__items list-unstyled">
                                  @for (location of locatons; track location) {
                                    <li [class.is-active]="locationActive">
                                      <a href="javascript:void(0)" (click)="changeLocation(location)">
                                        {{location.description_1}}
                                      </a>
                                    </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        }
                        @for (item of categories; track item) {
                          @if (item.class_id == 0 || !item?.collations?.length) {
                            <div class="card card--categories">
                              <a
                                href="#categories-0"
                                class="card-title class-0"
                                data-toggle="collapse"
                                aria-expanded="true"
                                [ngClass]="{'collapsed': ( !locationActive || !collation)}">
                                <div class="card-title__text">
                                  <img
                                    class="icon icon--lg"
                                    alt=""
                                    [src]="'assets/class/sm-' + item.class_id + '.svg'"
                                    />
                                    <h4>{{item.class_name}}</h4>
                                  </div>
                                  <div class="card-title__caret">
                                    <svg class="icon">
                                      <use xlink:href="#dropdown"></use>
                                    </svg>
                                  </div>
                                </a>
                                <div class="card-body collapse" id="categories-0" data-parent="#categories-accordion"
                                  [ngClass]="{'show': (!locationActive && !collation)}">
                                  <div class="card__content">
                                    <ul class="card__items list-unstyled">
                                      <li [class.is-active]="(!locationActive && !collation)">
                                        <a href="javascript:void(0)" (click)="changeClassItem(item.class_id)">
                                          {{person?.firstname ? person?.firstname + ' ' + person?.lastname : person?.businessname}}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (item?.collations?.length) {
                              <div class="card card--categories">
                                <a
                                  [href]="'#categories-' + item.class_id"
                                  [class]="'card-title class-' + item.class_id"
                                  data-toggle="collapse"
                                  [ngClass]="{'collapsed': collation?.class_id !== item.class_id}"
                                  aria-expanded="false">
                                  <div class="card-title__text">
                                    <img class="icon icon--lg" alt=""
                                      [fallbackImage]="'assets/class/sm-0.svg'"
                                      [src]="'assets/class/sm-' + item.class_id + '.svg'" />
                                      <h4>{{item.class_name}}</h4>
                                    </div>
                                    <div class="card-title__caret">
                                      <svg class="icon">
                                        <use xlink:href="#dropdown"></use>
                                      </svg>
                                    </div>
                                  </a>
                                  <div class="card-body collapse"
                                    [id]="'categories-' + item.class_id"
                                    [ngClass]="{'show': collation?.class_id == item.class_id}"
                                    data-parent="#categories-accordion">
                                    <div class="card__content">
                                      <ul class="card__items list-unstyled">
                                        @for (c of item?.collations; track c) {
                                          @if (c?.description_1?.split('|')[2]) {
                                            <li
                                              [class.is-active]="collation?.class_id == c.class_id && collation?.session_item_id == c.session_item_id">
                                              <a href="javascript:void(0)"
                                                [class]="item.class_id + '-' + c.session_item_id"
                                                [attr.data-category]="item.class_id"
                                                (click)="changeClassItem(c.class_id, c.session_item_id)">
                                                {{c?.description_1?.split('|')[2]}}
                                              </a>
                                            </li>
                                          }
                                        }
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      <div class="modal-edit__maincol">
                        <div class="card card--edit">
                          <div class="card-body">
                            <div class="card__header">
                              <h5 class="selected-category-item">{{collation?.description_1?.split('|')[2]}}</h5>
                              <div class="card__header-price">
                                <p>
                                  <strong class="item-price">
                                    {{ globalQuestionService?.accounting?.formatMoney(collation?.prem_value)}}
                                  </strong>
                                </p>
                              </div>
                              <blockquote class="callout">
                                <div class="callout__avatar">
                                  <img
                                    [src]="'assets/' + sessionDetails?.category_id + '/avatar/happy.png'"
                                    class="img-fluid"
                                    alt=""
                                    />
                                  </div>
                                  <div class="callout__content">
                                    <p>Please note that changes to your answers may affect your insurance premium.</p>
                                  </div>
                                </blockquote>
                              </div>

                              <div id="modal-content" class="card__content">
                                @for (question of questions; track question; let last = $last) {
                                  <!--Checkbox Select-->
                                  @if (question?.hidden === 0) {
                                    <app-question-controller
                                      [question]="question"
                                      [showLabel]="true"
                                      [controlCssClass]="(!last ? ' mb-30' : '')"
                                      [readOnly]="readonly"
                                      [isEditModal]="true"
                                      [showParent]="false"
                                      [funeralMemberQuestions]="childrenQuestions"
                                      [childItemQuestions]="getItemChildrenQuestions(question)"
                                      (questionAnswer)="questionResponse($event)">
                                    </app-question-controller>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-edit__tray">
                  <div class="container">
                    @if (+product?.is_ei_product === 1) {
                      <div class="modal-edit__summary">
                        <div class="modal-edit__summary-address selected-category-item">
                          {{collation ? collation?.description_1.split('|')[2] : person?.firstname + ' ' + person?.lastname}}
                        </div>
                        @if (collation) {
                          <div class="modal-edit__summary-price">
                            <p>
                              <strong>
                                <em class="item-price">
                                  {{ globalQuestionService?.accounting.formatMoney(collation?.prem_value)}}
                                </em>
                              </strong>
                            </p>
                          </div>
                        }
                      </div>
                    }
                    <div class="modal-edit__button">
                      <!--<a class="button button&#45;&#45;lg button&#45;&#45;secondary" data-dismiss="modal">Cancel</a>
                      <a class="button button&#45;&#45;lg button&#45;&#45;secondary" disabled >Cancel</a>-->
                      @if (+product?.is_ei_product === 1) {
                        <button class="button button--lg button--primary" (click)="save()">Save</button>
                      }
                      @if (+product?.is_ei_product === 0) {
                        <button class="button button--block button--lg button--primary" (click)="updateTPQChanges()">I'm Done</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade modal--alert" id="modal-additional" tabindex="-1" role="dialog"
            aria-labelledby="modal-additional-qs-1" aria-modal="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content modal-alert modal-alert--alt">

                <div class="modal-alert__heading">
                  <div class="container">
                    <div class="modal-alert__avatar">
                      <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                    </div>
                    <button class="modal-alert__close" data-dismiss="modal">
                      <svg class="icon">
                        <use xlink:href="#close-medium"></use>
                      </svg>
                    </button>
                  </div>
                </div>

                <div class="modal-alert__content">
                  <div class="container">
                    <div class="rte">
                      <h3>Changing this answer may require additional questions.</h3>
                      <p>Note that changes may affect your premium. All previously answered questions that don’t require changes
                      will still be saved.</p>
                    </div>
                  </div>
                </div>

                <div class="modal-alert__button">
                  <div class="container">
                    <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
                    <a href="#" class="button button--lg button--primary" (click)="startFlow()" data-toggle="modal"
                    data-dismiss="modal">Got it</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade modal--alert" id="modal-more-mini-flow" tabindex="-1" role="dialog" aria-labelledby="modal-discount-flow" aria-modal="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content modal-alert modal-alert--alt">

                <div class="modal-alert__heading">
                  <div class="container">
                    <div class="modal-alert__avatar">
                      <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
                    </div>
                    <button class="modal-alert__close" data-dismiss="modal">
                      <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                    </button>
                  </div>
                </div>
                <div class="modal-alert__content">
                  <div class="container">
                    <div class="rte">
                      <h3></h3>
                      <p></p>
                    </div>
                    @if (question) {
                      <app-question-mini-flow-controller
                        [question]="question" [edit]="true" [item_id]="question?.item_id" (questionAnswer)="moreFlowDone($event)">
                      </app-question-mini-flow-controller>
                    }
                  </div>

                </div>
              </div>
            </div>
          </div>
